/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  ProductDraftsUserControllerUpdateMutationRequest,
  ProductDraftsUserControllerUpdateMutationResponse,
  ProductDraftsUserControllerUpdatePathParams,
  ProductDraftsUserControllerUpdate400,
  ProductDraftsUserControllerUpdate401,
  ProductDraftsUserControllerUpdate404,
  ProductDraftsUserControllerUpdate409,
} from '../types/ProductDraftsUserControllerUpdate.ts';

function getProductDraftsUserUpdateUrl(id: ProductDraftsUserControllerUpdatePathParams['id']) {
  const res = { method: 'PATCH', url: `/api/user/product-drafts/${id}` as const };
  return res;
}

/**
 * {@link /api/user/product-drafts/:id}
 */
export async function productDraftsUserUpdate(
  id: ProductDraftsUserControllerUpdatePathParams['id'],
  data: ProductDraftsUserControllerUpdateMutationRequest,
  config: Partial<RequestConfig<ProductDraftsUserControllerUpdateMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    ProductDraftsUserControllerUpdateMutationResponse,
    ResponseErrorConfig<
      | ProductDraftsUserControllerUpdate400
      | ProductDraftsUserControllerUpdate401
      | ProductDraftsUserControllerUpdate404
      | ProductDraftsUserControllerUpdate409
    >,
    ProductDraftsUserControllerUpdateMutationRequest
  >({ method: 'PATCH', url: getProductDraftsUserUpdateUrl(id).url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
